export default __webpack_public_path__ + "static/media/G_wdt_c_cap_1.f3a6ee33.mp3";